import React, { useEffect, useMemo, useState } from 'react';
import {
  LocalOpsLiveProvider,
  useLocalOpsLive,
} from '../../context/LocalOpsLiveContext';
import LocalOpsFeedItem from './LocalOpsFeedItem';
import { formatRelativeTime } from '../../utils/localOpsTime';
import './localops.css';

const DEFAULT_QR_URL =
  'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1677560946/qr_test_8wMaHU4F90CO2ME6oo_x7krc7.png';
const ROTATE_MS = 5200;
const DISPLAY_COUNT = 6;

function LocalOpsDisplaySurface() {
  const { events } = useLocalOpsLive() || { events: [] };
  const [cursor, setCursor] = useState(0);
  const now = Date.now();

  const publicEvents = useMemo(
    () => (events || []).filter((event) => event?.visibility === 'public'),
    [events],
  );

  useEffect(() => {
    if (!publicEvents.length) return;
    const timer = setInterval(
      () => setCursor((prev) => (prev + 1) % publicEvents.length),
      ROTATE_MS,
    );
    return () => clearInterval(timer);
  }, [publicEvents.length]);

  const displayEvents = useMemo(() => {
    if (!publicEvents.length) return [];
    const start = cursor % publicEvents.length;
    return Array.from({
      length: Math.min(DISPLAY_COUNT, publicEvents.length),
    }).map((_, idx) => publicEvents[(start + idx) % publicEvents.length]);
  }, [publicEvents, cursor]);

  const qrUrl =
    process.env.REACT_APP_LOCALOPS_QR_URL ||
    process.env.REACT_APP_QR_CODE_URL ||
    DEFAULT_QR_URL;
  const joinUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}/register`
      : '/register';

  return (
    <div className="localops-display">
      <div className="localops-display__header">
        <div className="localops-display__title">LocalOps Live</div>
        <div className="localops-display__subtitle">
          Real-time local activity, privacy-safe and human.
        </div>
      </div>
      <div className="localops-display__feed">
        {displayEvents.length ? (
          displayEvents.map((event) => (
            <LocalOpsFeedItem
              key={event.id}
              event={event}
              timeAgoLabel={formatRelativeTime(event.createdAt, now)}
              variant="display"
            />
          ))
        ) : (
          <div className="localops-feed-empty">
            Activity will appear here as locals jump in.
          </div>
        )}
      </div>
      <div className="localops-display__footer">
        <div>
          <div className="localops-display__cta">Join JG LocalOps</div>
          <div className="localops-display__url">{joinUrl}</div>
        </div>
        <div className="localops-display__qr">
          <img src={qrUrl} alt="" />
        </div>
      </div>
    </div>
  );
}

export default function LocalOpsDisplayMode() {
  return (
    <LocalOpsLiveProvider mode="public">
      <LocalOpsDisplaySurface />
    </LocalOpsLiveProvider>
  );
}
